import React, { useCallback } from 'react';
import { FeatureAccess } from '@moodys/cre-cpm-client-apis.apis.services.auth';
import { useAuthContext } from "@moodys/cre-cpm-platform-shared.contexts.auth-context"

export const withFeatureAccess = <P extends object>(
  Component: React.ComponentType<P>,
  allowedFor: Partial<FeatureAccess[]>,
  notAvailableComponent?: JSX.Element,
): React.FC<P> => ({ ...props }) => {
    const { featureAccess } = useAuthContext()

    const isAllowed = useCallback(
      () => featureAccess.some(
          (feature: FeatureAccess) => allowedFor.includes(feature),
        ),
      [allowedFor, featureAccess],
    );
    // Current @type/react is not getting this type properly and we can not
    // install a newer version for types. Checked and running on hub normally
    // also for unit tests than render the component on this package
    // About props spreading is needed by definition with HOCs
    // @ts-ignore
    // eslint-disable-next-line  react/jsx-props-no-spreading
    return isAllowed() ? <Component {...props} /> : notAvailableComponent ?? null;
  };
